import * as $ from 'jquery';

export function setupRegistration() {
    const $courtFields = $('#court-registration-fields');
    const updateCourtFields = () => {
        $courtFields.toggle($('#reason-court').is(':checked'));
    };

    $('#reason-court, #reason-personal').on('change', updateCourtFields);
    updateCourtFields();

    const $referopen = $('#referopen');

    $referopen.on("click", function () {
        $('#referfields').show('slow');
        $('#referopenarea').hide();
    });

    const $billinfo = $('#BillingInfo');

    if ($('#HasBillingAddress').is(':checked')) {
        $billinfo.show();
    }
    else {
        $billinfo.hide();
    }
    $('#HasBillingAddress').on("click", function () {
        if ($('#HasBillingAddress').is(':checked')) {
            $billinfo.slideDown("fast");
        }
        else {
            $billinfo.slideUp("fast");
        }
    });

    $('.cvnshow').on("click", function () {
        window.open("/Enroll/CVNPopup", "cvn", "menubar=0,resizable=0,width=650,height=550");
    });
}
